import styled from 'styled-components';

import { colors } from '../../../../styles/constants';

export const ProSignUpSuccessMessageBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 4px 17px -3px rgba(43, 43, 43, 0.15);
  background-color: #fff;
  padding: 40px 28px 28px 28px;
  border-radius: 8px;
`;

export const ProSignUpSuccessMessageBlockTitle = styled.div`
  margin-bottom: 12px;
`;

export const ProSignUpSuccessMessageBlockSubTitle = styled.div`
  margin-bottom: 40px;
`;

export const ProSignUpSuccessMessageBlockErrorMessage = styled.div`
  margin-top: 24px;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  color: ${colors.red};
`;

export const ProSignUpSuccessMessageBlockSuccessMessage = styled.div`
  margin-top: 24px;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  color: ${colors.darkGreen};
`;
